module.exports = __webpack_public_path__ + "static/img/0d764591ef987ccb42343d0de1fc1e54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/图片4.png
// module id = i089
// module chunks = 1